import createKeyFactory, { FactoryQueryParams, KEYS } from 'utils/createKeyFactory';

const usersFactory = {
  ...createKeyFactory([KEYS.USERS]),
  myFriends: (params?: FactoryQueryParams) => [...usersFactory.all(), 'myFriends', ...usersFactory.list(params)],
  friends: (params?: FactoryQueryParams) => [...usersFactory.all(), 'friends', ...usersFactory.list(params)],
  userStats: (id: string) => [...usersFactory.details(id), 'stats'],
  seasonPass: (id: string) => [...usersFactory.details(id), 'seasonPass'],
  myRequests: (params?: FactoryQueryParams) => [...usersFactory.all(), 'myRequests', ...usersFactory.list(params)],
  searchFriends: (params?: FactoryQueryParams) => [
    ...usersFactory.all(),
    'searchFriends',
    ...usersFactory.list(params),
  ],
  blockedFriends: (params?: FactoryQueryParams) => [
    ...usersFactory.all(),
    'blockedFriends',
    ...usersFactory.list(params),
  ],
  profile: (id: string) => [...usersFactory.details(id), 'profile'],
};

export default usersFactory;
